import { useTranslation } from 'react-i18next';
import Banner from '@assets/banner/banner_2048x672.jpg';

export const Hero = () => {
    const { t } = useTranslation();

    return (
        <div
            className="h-[450px] sm:h-[350px] bg-cover bg-center"
            style={{ backgroundImage: `url(${Banner})` }}
        >
            {/* Image overlay */}
            {/*<div className="w-full h-full backdrop-brightness-50 flex items-center">*/}
            <div className="w-full h-full bg-black/50 flex items-center">

                {/* Text block with max-width and side margins */}
                <div className="max-w-[1280px] mx-auto px-8 py-0 text-herotxt relative z-10">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold">{t('hero.headline')}</h1>
                    <p className=" text-lg  md:text-xl  lg:text-2xl mt-5">{t('hero.text')}</p>
                    <button className="btn btn-outline mt-5">
                        <a href="mailto:info@baseunit.ch">
                            {t('hero.contact')}
                        </a>
                    </button>
                </div>

            </div>
        </div>
    );
};